<template>
    <div>
    </div>
</template>
<script setup>
import { onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
const route = useRoute();
const router = useRouter();
onMounted(async () => {
    console.log('route', route)
    console.log('router', router)
    goIndex()
});
const goIndex = () => {
    router.replace({
        path: route.query.path
    })
}
</script>
